import React, { FC } from 'react';
import AttributeHeader, { AttributeHeaderProps } from './AttributeHeader';
import RadioButton from 'components/RadioButton';
import { RadioButtonProps } from 'components/RadioButton/RadioButton';

interface CardRadioProps
  extends AttributeHeaderProps,
    Pick<RadioButtonProps, 'horizontal' | 'containerClass'> {
  onClick: (id: string) => void;
  options: { label: string; value: string }[];
  selected: string | null;
}

const CardRadio: FC<CardRadioProps> = ({
  onClick,
  options,
  selected,
  horizontal,
  containerClass,
  ...attributeHeaderProps
}) => {
  return (
    <div>
      <AttributeHeader {...attributeHeaderProps} />
      <RadioButton
        className="px-6"
        containerClass={containerClass}
        options={options}
        variant="blue"
        horizontal={horizontal}
        selectedValue={selected ?? undefined}
        onChange={(value) => onClick(value)}
      />
    </div>
  );
};

export default CardRadio;
